/* eslint-disable  react/display-name */
import React from 'react';
import { pushNotificationAction } from 'actions/app-actions';
import { NOTIFICATION_TYPE } from 'components/v2/notification/notification';
import _get from 'lodash/get';

export const pushDeleteDeliveryNotification = (delivery, revertFunc) => {
  const dropOffs = _get(delivery, 'detail.dropOffs', []);
  const recipientName =
    dropOffs.length === 1 ? dropOffs[0].name : `${dropOffs.length} recipients`;
  const message = `Delivery to ${recipientName} deleted`;
  const description = revertFunc
    ? () => <a onClick={revertFunc}> Undo </a>
    : undefined;
  return pushNotificationAction({
    id: `delete-${delivery.id}`,
    type: NOTIFICATION_TYPE.CONFIRMED,
    message,
    description,
  });
};

export default {};
